require '../transforms/mixed'

backgroundStyleProp = require 'utils/background-style-prop'

###
# Модель организации
###
App.Organization = DS.Model.extend
  name  : DS.attr 'string'
  site_name  : DS.attr 'string'
  about : DS.attr 'string'
  phone : DS.attr 'string'
  logo  : DS.attr 'string'
  logo_small_url  : DS.attr 'string'
  logo_medium_url : DS.attr 'string'
  
  cities: DS.attr 'mixed'

  google_analytics_code: DS.attr 'string'
  yandex_metrika_code: DS.attr 'string'

  code_gtm:         DS.attr 'string'
  code_fb_pixel:    DS.attr 'string'
  code_vk_pixel:    DS.attr 'string'
  code_mail_pixel:  DS.attr 'string'

  track_data_layer: DS.attr 'boolean'

  meta_title:       DS.attr 'string'
  meta_description: DS.attr 'string'
  meta_image:       DS.attr 'string'

  login:    DS.attr 'string'
  password: DS.attr 'string'

  host      : DS.attr 'string'
  embedded_content  : DS.attr 'string'
  head_embedded_content  : DS.attr 'string'
  board_embedded_content  : DS.attr 'string'

  show_main      : DS.attr 'boolean'
  social_network : DS.attr 'mixed'
  social_networks: Em.computed.alias('social_network')

  phone_mask: DS.attr 'string'

  currency: DS.attr 'mixed'

  features: DS.attr 'mixed'

  dish_attributes:     DS.attr 'mixed'
  modifier_attributes: DS.attr 'mixed'

  bonus_enabled: DS.attr 'boolean'

  categories_for_tree_view: DS.attr 'mixed'

  menu_published_at : DS.attr 'date'
  menu_changed_at   : DS.attr 'date'
  is_menu_actual    : DS.attr 'boolean'
  is_published:       DS.attr 'boolean'

  accept_cashless:     DS.attr 'boolean'
  accept_cash:         DS.attr 'boolean'
  accept_courier_card: DS.attr 'boolean'

  timezone: DS.attr 'string'
  timezone_own: DS.attr 'string'

  env: Em.inject.service('environment')

  # Нормализованный хостнейм организации
  normalizedHost: (->
    host = @get('host')

    if not Em.isEmpty( host )
      return host

    previewTemplate = @get('env.organizationIdHost')
    organization_id = @get('id')

    previewTemplate.replace('{id}', organization_id)
  ).property(
    'host',
    'env.organizationIdHost',
    'id' )

  # Внешние связи
  restaurants    : DS.hasMany 'restaurant',    async : true
  dishes         : DS.hasMany 'dish',          async : true
  categories     : DS.hasMany 'category',      async : true
  delivery_zones : DS.hasMany 'delivery_zone', async : true
  promos         : DS.hasMany 'promo',         async : true
  cooking_lines  : DS.hasMany 'cooking_line',  async : true

  avatarPlaceholder: 'images/organization-placeholder.png'

  safePhotoMedium: (->
    @get('logo_medium_url') or @get('avatarPlaceholder')
  ).property('logo_medium_url')

  safePhotoSmall: (->
    @get('logo_small_url') or @get('avatarPlaceholder')
  ).property('logo_small_url')

  logoMediumBackground: backgroundStyleProp('safePhotoMedium')
  logoSmallBackground:  backgroundStyleProp('safePhotoSmall')

  get_categories_for: (root_id, level)->
    ret = []
    @get('categories_for_tree_view').forEach((c) =>
      if c.get('parent.id') == root_id
        c.set('level', level)
        ret.push c
        ret = ret.concat(@get_categories_for(c.get('id'), level + 1))
    )
    ret


  categories_tree_view: ((root_id, level)->
    return new Ember.RSVP.Promise (resolve, reject) =>
      unless @get('categories_for_tree_view')
        @store.find('category').then (ccc) =>
          @set('categories_for_tree_view', ccc)
          resolve(@get_categories_for(null, 0))
      else
        resolve(@get_categories_for(null, 0))

  ).property('categories', 'categories_for_tree_view')

  publish: ->
    @nonRESTAction('POST', 'publish')

  checklist: ->
    @nonRESTAction('GET', 'checklist')

  statsDynamics: (query={}) ->
    @nonRESTAction('GET', 'stats/dynamics', query)

  statsClients: (query={}) ->
    @nonRESTAction('GET', 'stats/clients', query)

  statsBaskets: (query={}) ->
    @nonRESTAction('GET', 'stats/baskets', query)

  uploadLogo: (file) ->
    @fileUpload('logo', file)

  removeLogo: (file) ->
    @nonRESTAction('DELETE', 'logo')

  uploadMetaImage: (file) ->
    @fileUpload('meta_image', file)

  sendSupportIssue: (data, files) ->
    @fileUpload('support_issue', files, { type: 'POST', formDataParams: data })

  menuImportStatus: ->
    @nonRESTAction('GET', 'import/menu')

  clientsImportStatus: ->
    @nonRESTAction('GET', 'import/clients')

  checkHost: (query={}) ->
    @nonRESTAction('GET', 'check_host', query)

  exportMenu: (query={}) ->
    @nonRESTAction('GET', "export/menu", query)
